import api from './api.js';

class CustomerFavorites {
    constructor(){
        this.lookup_url = 'Customers/Favorites';
    }

    getFavorites() {
        return api.get(this.lookup_url);
    }

    addFavorite(customerId) {
        return api.post(`${this.lookup_url}/${customerId}`);
    }

    removeFavorite(customerId) {
        return api.delete(`${this.lookup_url}/${customerId}`);
    }
}

export default new CustomerFavorites;
